import { useCallback, useMemo } from 'react'
import { Database } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchMigrations, DT_STR as S, type MigrationRow } from './devtoolsApi'

/**
 * A27.10 — Миграции БД (version + applied state, read-only). FUNCTIONAL: reads
 * the real `/admin/devtools/migrations` (embedded migration files paired with
 * the live schema_migrations version). Placeholder permission USERS_VIEW.
 */
export function MigrationsScreen() {
  const columns = useMemo<AdminColumn<MigrationRow>[]>(
    () => [
      { key: 'version', header: S.version, type: 'text' },
      { key: 'name', header: S.name, type: 'text' },
      { key: 'applied', header: S.applied, type: 'text' },
      { key: 'applied_at', header: S.appliedAt, type: 'text' },
    ],
    [],
  )
  const fetcher = useCallback(fetchMigrations, [])
  return (
    <>
      <PageHeader title={S.migrations} screenId="A27.10" />
      <DataTable<MigrationRow>
        screenId="A27.10"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => r.version}
        exportable
        emptyState={{ icon: <Database size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
